import { refCaption } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { CaptionDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["CAPTION_QUEUE_URL"]

export const getRefCaptionData = async (
  tx: DbTransaction,
  id: string,
): Promise<CaptionDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refCaption.id,
      fieldUniqueId: refCaption.fieldUniqueId,
      textEn: refCaption.text_en,
      textTranslations: refCaption.text_translations,
      createdAt: refCaption.createdAt,
      createdBy: refCaption.createdBy,
      updatedAt: refCaption.updatedAt,
      updatedBy: refCaption.updatedBy,
    })
    .from(refCaption)
    .where(eq(refCaption.id, id))

  if (!row) {
    console.error(`RefCaption with id ${id} not found`)
    return
  }

  const refCaptionDoc: CaptionDoc = {
    id: row.id,
    field_unique_id: row.fieldUniqueId,
    text_en: row.textEn,
    text_translations:
      (row.textTranslations as Array<{ lang: string; text: string }>) ?? null,
    created_at: row.createdAt.getTime(),
    created_by: row.createdBy,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refCaptionDoc,
  })

  return refCaptionDoc
}

export const saveRefCaptionToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefCaptionData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
